var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes.root,on:{"click":_vm.click}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"color":_vm.colors.icon}}):_vm._e(),(_vm.label)?_c('div',{class:_vm.classes.labelContainer},[_c('span',{class:_vm.classes.label},[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }